import React, { useEffect, useState } from 'react';
import {UpCircleFilled} from '@ant-design/icons';
import classNames from 'classnames';
import {Button} from '@life-line-lab/components-react';
import './backtop.scss'

export const BackTop = () => {
    const [isVisible, setIsVisible] = useState(false)

    const toggleVisibility = () => {
        if(window.pageYOffset >300){
        setIsVisible(true)
        } 
    else {
        setIsVisible(false)
        }
    }

    const backToTop = () => {
        window.scrollTo({
            top:0, 
            behavior:'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll',toggleVisibility)

        return () =>{
            window.removeEventListener("scroll",toggleVisibility)
        }
    },[])


    return (
        <div className='backTop'>
            <UpCircleFilled onClick={backToTop}
                className={classNames(isVisible ? 'show' : 'hide')}
                />
        </div>
    )
}
export default BackTop;